
import React, { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Button, Box, Typography, Alert } from '@mui/material';

export default function LoginPage() {
  const { instance, accounts, inProgress, error } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [msalError, setMsalError] = useState(null);

  useEffect(() => {
    if (error) {
      setMsalError(error.message || JSON.stringify(error));
    }
  }, [error]);

  useEffect(() => {
    // Debug output for MSAL state
    // eslint-disable-next-line no-console
    console.log('MSAL accounts:', accounts);
    // eslint-disable-next-line no-console
    console.log('MSAL inProgress:', inProgress);
    // eslint-disable-next-line no-console
    console.log('MSAL isAuthenticated:', isAuthenticated);
    // eslint-disable-next-line no-console
    console.log('MSAL error:', error);
  }, [accounts, inProgress, isAuthenticated, error]);

  const handleLogin = () => {
    setMsalError(null);
    instance.loginRedirect({
      scopes: ["User.Read"]
    }).catch(e => {
      setMsalError(e.message || JSON.stringify(e));
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ mb: 3 }}>Sign in to Ratex Dashboard</Typography>
      {msalError && (
        <Alert severity="error" sx={{ mb: 2 }}>{msalError}</Alert>
      )}
      <Button variant="contained" color="primary" onClick={handleLogin}>
        Sign in with Microsoft
      </Button>
      <Box sx={{ mt: 3, textAlign: 'left', maxWidth: 500 }}>
        <Typography variant="body2" color="textSecondary">
          <strong>Debug Info:</strong><br />
          Authenticated: {String(isAuthenticated)}<br />
          Accounts: {accounts && accounts.length ? JSON.stringify(accounts) : 'None'}<br />
          In Progress: {inProgress}<br />
        </Typography>
      </Box>
    </Box>
  );
}
